// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-search {
  margin-top: 12px;
}

.catalog-search .search-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.catalog-search .search-row input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.875rem;
}

.catalog-search .search-row button {
  padding: 8px 16px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
}

.catalog-search .search-row button:hover {
  background: #1d4ed8;
}

.catalog-search table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.catalog-search th,
.catalog-search td {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #e5e7eb;
}

.catalog-search th {
  background: #f3f4f6;
  font-weight: 600;
}

.catalog-search .btn-add-item {
  padding: 4px 10px;
  background: #16a34a;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.catalog-search .btn-add-item:hover {
  background: #15803d;
}

.catalog-search .pagination {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  align-items: center;
  font-size: 0.875rem;
}

.catalog-search .pagination button {
  padding: 4px 12px;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.catalog-search .pagination button:disabled {
  opacity: 0.5;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/CatalogSearch.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".catalog-search {\n  margin-top: 12px;\n}\n\n.catalog-search .search-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.catalog-search .search-row input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.875rem;\n}\n\n.catalog-search .search-row button {\n  padding: 8px 16px;\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.catalog-search .search-row button:hover {\n  background: #1d4ed8;\n}\n\n.catalog-search table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.catalog-search th,\n.catalog-search td {\n  text-align: left;\n  padding: 6px 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.catalog-search th {\n  background: #f3f4f6;\n  font-weight: 600;\n}\n\n.catalog-search .btn-add-item {\n  padding: 4px 10px;\n  background: #16a34a;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.catalog-search .btn-add-item:hover {\n  background: #15803d;\n}\n\n.catalog-search .pagination {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  align-items: center;\n  font-size: 0.875rem;\n}\n\n.catalog-search .pagination button {\n  padding: 4px 12px;\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.catalog-search .pagination button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
